import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Banner from "../../../Components/Common/Banner";
import CareerImg from "../../../Assets/images/BannerImages/Career.png";
import getAJob from "../../../Assets/images/Career/getAJob.png";
import { CiCalendar, CiLocationOn } from "react-icons/ci";
import { IoMdTimer } from "react-icons/io";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import GetInTouchUs from "../../../Components/Common/GetInTouchUs";
import JobApplicationModal from "./JobApplicationModal";
import axios from "axios";

const CareerDetail = () => {
  const [jobData, setJobData] = useState([]);
  const location = useLocation();
  const data = location?.state?.post;
  console.log(location?.state?.post);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");

  const handleOpen = (id) => {
    setOpen(true);
    setSelectedJob(id);
  };
  const handleClose = () => setOpen(false);

  const navigateToDetail = (post) => {
    console.log(post);

    const titleWithDashes = post.job_title.replace(/\s+/g, "-"); // Replace spaces with dashes
    navigate(`/contact-us/career/${encodeURIComponent(titleWithDashes)}`, {
      state: { post },
    });
  };

  const getTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const secondsAgo = Math.floor((now - date) / 1000);

    if (secondsAgo < 60) {
      return `${secondsAgo} seconds ago`;
    } else if (secondsAgo < 3600) {
      const minutesAgo = Math.floor(secondsAgo / 60);
      return `${minutesAgo} minutes ago`;
    } else if (secondsAgo < 86400) {
      const hoursAgo = Math.floor(secondsAgo / 3600);
      return `${hoursAgo} hours ago`;
    } else if (secondsAgo < 2592000) {
      const daysAgo = Math.floor(secondsAgo / 86400);
      return `${daysAgo} days ago`;
    } else if (secondsAgo < 31536000) {
      const monthsAgo = Math.floor(secondsAgo / 2592000);
      return `${monthsAgo} months ago`;
    } else {
      const yearsAgo = Math.floor(secondsAgo / 31536000);
      return `${yearsAgo} years ago`;
    }
  };

  const getAllJobOpenings = () => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/job-openings/get-all-openings`
      )
      .then((response) => {
        const sortedJobs = response.data.sort(
          (a, b) => new Date(b.posted_date_time) - new Date(a.posted_date_time)
        );
        const recentJobs = sortedJobs.slice(0, 3);
        setJobData(recentJobs);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllJobOpenings();
  }, []);

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      <Banner
        pageName={data?.job_title}
        breadcrummbs={`Home / Contact Us / Career / ${data?.job_title}`}
        bgimage={CareerImg}
      />
      <div className="lg:px-20 md:px-10 px-5 py-10 tracking-wider">
        <div className="flex lg:flex-row flex-col gap-4">
          <div className=" lg:w-[75%] h-auto ">
            <div className="w-full p-4 flex flex-col gap-1 border border-gray-300 rounded-lg">
              <div className="flex justify-between">
                <p className="text-secondaryTextColor">{data?.company_name}</p>
                <p className="font-medium">₹ {data?.salary} Month</p>
              </div>
              <h1 className="text-xl font-bold">{data?.job_title}</h1>
              <div className="flex items-center text-secondaryTextColor gap-1">
                <CiLocationOn />
                <p className="text-sm">{data?.job_location}</p>
              </div>
              <p>Type : {data?.job_type}</p>
              <hr className="border-3 border-gray-400 my-2" />
              <div className="flex items-center justify-between">
                <p className="">{getTimeAgo(data.posted_date_time)}</p>
                <button
                  onClick={() => handleOpen(data?._id)}
                  className="bg-primaryOrangeColor hover:bg-primaryDarkColor text-white px-8 py-2 rounded"
                >
                  Apply
                </button>
              </div>
            </div>
            <div className=" border border-gray-300 rounded-lg mt-2 p-4">
              <h2 className="font-bold">Job Description :</h2>
              <hr className="my-2" />
              <div>
                {data?.job_descriptions?.map((ele) => (
                  <li>{ele}</li>
                ))}
              </div>

              <h2 className="font-bold mt-4">Requirements :</h2>
              <hr className="my-2" />
              <div>
                {data?.requirements?.map((ele) => (
                  <li>{ele}</li>
                ))}
              </div>
            </div>

            <div className="border border-gray-300 rounded-lg mt-2 p-4 flex flex-col gap-1">
              <div className="flex gap-2 items-center">
                <p className="lg:text-xl">Role :</p>
                <p>{data?.job_title}</p>
              </div>
              <div className="flex gap-2 items-center">
                <p className="lg:text-xl">Industry Type :</p>
                <p>{data?.industry_type}</p>
              </div>
              <div className="flex gap-2 items-center">
                <p className="lg:text-xl">Employment Type :</p>
                <p>{data?.job_type}</p>
              </div>
              <div className="flex gap-2 items-center flex-wrap">
                <p className="lg:text-xl">Skills :</p>
                <div className="flex gap-2">
                  {data?.skills?.map((ele, ind) => (
                    <p
                      className={`${
                        ind % 2 == 0 ? "bg-blue-100" : "bg-green-100"
                      } md:px-4 px-2 py-1`}
                    >
                      {ele}
                    </p>
                  ))}
                </div>
              </div>
            </div>
            <div className="border border-gray-300 rounded-lg mt-2 p-4">
              <h2 className="font-bold">About Company :</h2>
              <p className="font-light text-secondaryTextColor">
                unknown.com is one of the leading online matrimonial services
                offering various opportunities to people to meet their
                soul-mates on a single platform. The site is one of the fast
                growing matrimonial portals working towards creating the
                matrimony alliances and successful marriages. The portal extends
                its services to people belonging to different backgrounds,
                regions, casts and religions. The services are offered to
                privileged Indians from Hindu, Sikh, Muslims, Christians, Jain
                and other communities world-wide.
              </p>
            </div>
          </div>
          <div className="lg:w-[25%] h-auto rounded-lg">
            <img
              src={getAJob}
              alt="image"
              className="w-full mb-4 lg:flex hidden"
            />
            {jobData?.map((post) => (
              <div
                key={post.id}
                onClick={() => {
                  scrollUp();
                  navigateToDetail(post);
                }}
                className="flex lg:flex-row flex-col gap-2 p-4 border border-gray-200 mb-2 rounded cursor-pointer shadow-md"
              >
                <div className="lg:w-[90%] flex flex-col gap-2">
                  <div className="flex items-center justify-between xl:text-sm lg:text-xs">
                    <p className="font-medium">{post?.company_name}</p>{" "}
                    <span className="bg-violet-200 px-2 py-1">New Post</span>
                  </div>
                  <h1 className="font-bold text-lg">{post?.job_title}</h1>
                  <div className="flex flex-wrap gap-2 justify-between">
                    <div className="flex items-center text-secondaryTextColor gap-1">
                      <CiLocationOn />
                      <p className="text-sm">{post?.job_location}</p>
                    </div>
                    <div className="flex items-center text-secondaryTextColor gap-1">
                      <IoMdTimer />
                      <p className="text-sm">{post?.job_type}</p>
                    </div>
                    <div className="flex items-center text-secondaryTextColor gap-1">
                      <RiMoneyDollarCircleLine />
                      <p className="text-sm">{post?.salary}</p>
                    </div>
                    <div className="flex items-center text-secondaryTextColor gap-1">
                      <CiCalendar />
                      <p className="text-sm">
                        {getTimeAgo(post?.posted_date_time)}
                      </p>
                    </div>
                  </div>
                  <p className="text-secondaryTextColor tracking-wide text-justify text-sm">
                    {post.JobLongDescription}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="my-10">
          <GetInTouchUs />
        </div>
      </div>
      <JobApplicationModal
        open={open}
        handleClose={handleClose}
        selectedJob={selectedJob}
      />
    </div>
  );
};

export default CareerDetail;
